document.addEventListener('DOMContentLoaded', () => {
  const raittingSection = document.querySelector('.jdgm-rev-widg__reviews');
  const button = document.querySelector('.btn-wrap .raitting');
  const buttons = document.querySelectorAll('.btn--scroll-smooth');

  /**
   * Smooth scroll to the target section with an offset from the top.
   *
   * @param {Event} event - The click event.
   */
  function smoothScroll(event) {
    event.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    const offset = 50; // Offset from the top in pixels

    window.scrollTo({
      top: target.offsetTop - offset,
      behavior: 'smooth',
    });
  }

  if (raittingSection) {
    if (button) {
      button.classList.remove('hidden');
    }
  }

  if (buttons) {
    buttons.forEach((element) => {
      element.addEventListener('click', smoothScroll);
    });
  }
});
